var _path, _g, _g2, _g3, _g4, _g5, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.893 73.8449C156.372 70.0517 163.628 70.0517 169.107 73.8449L231.107 116.768C235.424 119.757 238 124.673 238 129.923V189.157C238 194.407 235.424 199.323 231.107 202.312L169.107 245.235C163.628 249.028 156.372 249.028 150.893 245.235L88.8926 202.312C84.5759 199.323 82 194.407 82 189.157V129.923C82 124.673 84.5759 119.757 88.8926 116.768L150.893 73.8449Z",
    fill: "#24252A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter0_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3105_3858",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8926 -85.1551C56.3717 -88.9483 63.6282 -88.9483 69.1073 -85.1551L131.107 -42.232C135.424 -39.2435 138 -34.3272 138 -29.0769V30.1566C138 35.4069 135.424 40.3231 131.107 43.3117L69.1074 86.2347C63.6282 90.028 56.3718 90.028 50.8926 86.2347L-11.1074 43.3117C-15.4241 40.3231 -18 35.4069 -18 30.1566V-29.0769C-18 -34.3272 -15.4241 -39.2435 -11.1074 -42.232L50.8926 -85.1551Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-11.1074 -42.232L-11.6766 -43.0542L-11.1074 -42.232ZM-11.1074 43.3117L-10.5381 42.4895L-11.1074 43.3117ZM69.1074 86.2347L68.5381 85.4125L69.1074 86.2347ZM50.8926 86.2347L51.4619 85.4126L50.8926 86.2347ZM131.107 43.3117L131.677 44.1339L131.107 43.3117ZM69.1073 -85.1551L68.5381 -84.3329L69.1073 -85.1551ZM131.107 -42.232L131.677 -43.0542L131.107 -42.232ZM131.677 -43.0542L69.6766 -85.9773L68.5381 -84.3329L130.538 -41.4098L131.677 -43.0542ZM139 30.1566V-29.0769H137V30.1566H139ZM69.6766 87.0569L131.677 44.1339L130.538 42.4895L68.5381 85.4125L69.6766 87.0569ZM-11.6766 44.1339L50.3234 87.0569L51.4619 85.4126L-10.5381 42.4895L-11.6766 44.1339ZM-19 -29.0769V30.1566H-17V-29.0769H-19ZM50.3234 -85.9773L-11.6766 -43.0542L-10.5382 -41.4098L51.4618 -84.3329L50.3234 -85.9773ZM-17 -29.0769C-17 -33.9991 -14.5851 -38.608 -10.5382 -41.4098L-11.6766 -43.0542C-16.2631 -39.8789 -19 -34.6554 -19 -29.0769H-17ZM-10.5381 42.4895C-14.5851 39.6877 -17 35.0788 -17 30.1566H-19C-19 35.735 -16.2631 40.9585 -11.6766 44.1339L-10.5381 42.4895ZM68.5381 85.4125C63.4015 88.9687 56.5985 88.9687 51.4619 85.4126L50.3234 87.0569C56.145 91.0872 63.855 91.0872 69.6766 87.0569L68.5381 85.4125ZM137 30.1566C137 35.0788 134.585 39.6877 130.538 42.4895L131.677 44.1339C136.263 40.9585 139 35.735 139 30.1566H137ZM69.6766 -85.9773C63.855 -90.0076 56.145 -90.0076 50.3234 -85.9773L51.4618 -84.3329C56.5985 -87.889 63.4015 -87.889 68.5381 -84.3329L69.6766 -85.9773ZM130.538 -41.4098C134.585 -38.6081 137 -33.9991 137 -29.0769H139C139 -34.6554 136.263 -39.8789 131.677 -43.0542L130.538 -41.4098Z",
    fill: "#2E2F33",
    mask: "url(#path-2-inside-1_3105_3858)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter1_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.893 -85.1551C254.372 -88.9483 261.628 -88.9483 267.107 -85.1551L329.107 -42.232C333.424 -39.2435 336 -34.3272 336 -29.0769V30.1566C336 35.4069 333.424 40.3231 329.107 43.3117L267.107 86.2347C261.628 90.028 254.372 90.028 248.893 86.2347L186.893 43.3117C182.576 40.3231 180 35.4069 180 30.1566V-29.0769C180 -34.3272 182.576 -39.2435 186.893 -42.232L248.893 -85.1551Z",
    fill: "url(#paint0_linear_3105_3858)",
    fillOpacity: 0.12
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter2_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_3105_3858",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.107 233.845C261.628 230.052 254.372 230.052 248.893 233.845L186.893 276.768C182.576 279.757 180 284.673 180 289.923V349.157C180 354.407 182.576 359.323 186.893 362.312L248.893 405.235C254.372 409.028 261.628 409.028 267.107 405.235L329.107 362.312C333.424 359.323 336 354.407 336 349.157V289.923C336 284.673 333.424 279.757 329.107 276.768L267.107 233.845Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.107 276.768L329.677 275.946L329.107 276.768ZM329.107 362.312L328.538 361.489L329.107 362.312ZM248.893 405.235L249.462 404.413L248.893 405.235ZM267.107 405.235L266.538 404.413L267.107 405.235ZM186.893 362.312L186.323 363.134L186.893 362.312ZM248.893 233.845L249.462 234.667L248.893 233.845ZM186.893 276.768L186.323 275.946L186.893 276.768ZM186.323 275.946L248.323 233.023L249.462 234.667L187.462 277.59L186.323 275.946ZM179 349.157V289.923H181V349.157H179ZM248.323 406.057L186.323 363.134L187.462 361.489L249.462 404.413L248.323 406.057ZM329.677 363.134L267.677 406.057L266.538 404.413L328.538 361.489L329.677 363.134ZM337 289.923V349.157H335V289.923H337ZM267.677 233.023L329.677 275.946L328.538 277.59L266.538 234.667L267.677 233.023ZM335 289.923C335 285.001 332.585 280.392 328.538 277.59L329.677 275.946C334.263 279.121 337 284.345 337 289.923H335ZM328.538 361.489C332.585 358.688 335 354.079 335 349.157H337C337 354.735 334.263 359.959 329.677 363.134L328.538 361.489ZM249.462 404.413C254.599 407.969 261.401 407.969 266.538 404.413L267.677 406.057C261.855 410.087 254.145 410.087 248.323 406.057L249.462 404.413ZM181 349.157C181 354.079 183.415 358.688 187.462 361.489L186.323 363.134C181.737 359.959 179 354.735 179 349.157H181ZM248.323 233.023C254.145 228.992 261.855 228.992 267.677 233.023L266.538 234.667C261.401 231.111 254.599 231.111 249.462 234.667L248.323 233.023ZM187.462 277.59C183.415 280.392 181 285.001 181 289.923H179C179 284.345 181.737 279.121 186.323 275.946L187.462 277.59Z",
    fill: "#2E2F33",
    mask: "url(#path-5-inside-2_3105_3858)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter3_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1074 233.845C63.6283 230.052 56.3718 230.052 50.8927 233.845L-11.1074 276.768C-15.4241 279.757 -18 284.673 -18 289.923V349.157C-18 354.407 -15.4241 359.323 -11.1074 362.312L50.8926 405.235C56.3718 409.028 63.6282 409.028 69.1074 405.235L131.107 362.312C135.424 359.323 138 354.407 138 349.157V289.923C138 284.673 135.424 279.757 131.107 276.768L69.1074 233.845Z",
    fill: "url(#paint1_linear_3105_3858)",
    fillOpacity: 0.12
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 128,
    width: 176,
    height: 64,
    rx: 12,
    fill: "#18181B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 132.5,
    width: 167,
    height: 55,
    rx: 7.5,
    fill: "url(#paint2_linear_3105_3858)",
    stroke: "url(#paint3_linear_3105_3858)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94 132L94 188",
    stroke: "#303134"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116 132L116 188",
    stroke: "#303134"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138 132L138 188",
    stroke: "#303134"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160 132L160 188",
    stroke: "#303134"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182 132L182 188",
    stroke: "#303134"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204 118L204 202",
    stroke: "#303134"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226 123.5L226 196.5",
    stroke: "#303134"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 110,
    width: 16,
    height: 100,
    rx: 4,
    fill: "url(#paint4_linear_3105_3858)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 138,
    width: 16,
    height: 44,
    rx: 4,
    fill: "url(#paint5_linear_3105_3858)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 123,
    width: 16,
    height: 74,
    rx: 4,
    fill: "url(#paint6_linear_3105_3858)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 152,
    width: 4,
    height: 16,
    rx: 2,
    fill: "url(#paint7_linear_3105_3858)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 152,
    width: 4,
    height: 16,
    rx: 2,
    fill: "url(#paint8_linear_3105_3858)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter10_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 155,
    width: 4,
    height: 10,
    rx: 2,
    fill: "url(#paint9_linear_3105_3858)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter11_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 155,
    width: 4,
    height: 10,
    rx: 2,
    fill: "url(#paint10_linear_3105_3858)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 16,
    rx: 2,
    transform: "matrix(-1 0 0 1 52 152)",
    fill: "url(#paint11_linear_3105_3858)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 16,
    rx: 2,
    transform: "matrix(-1 0 0 1 44 152)",
    fill: "url(#paint12_linear_3105_3858)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter14_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 10,
    rx: 2,
    transform: "matrix(-1 0 0 1 36 155)",
    fill: "url(#paint13_linear_3105_3858)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter15_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 10,
    rx: 2,
    transform: "matrix(-1 0 0 1 28 155)",
    fill: "url(#paint14_linear_3105_3858)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 152,
    width: 16,
    height: 16,
    rx: 4,
    fill: "url(#paint15_linear_3105_3858)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 150,
    width: 16,
    height: 20,
    rx: 4,
    fill: "url(#paint16_linear_3105_3858)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 144,
    width: 16,
    height: 32,
    rx: 4,
    fill: "url(#paint17_linear_3105_3858)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 144,
    width: 16,
    height: 32,
    rx: 4,
    fill: "url(#paint18_linear_3105_3858)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 234,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint19_linear_3105_3858)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 232.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "url(#paint20_linear_3105_3858)",
    strokeWidth: 3
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_3105_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 46,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint21_linear_3105_3858)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 44.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "url(#paint22_linear_3105_3858)",
    strokeWidth: 3
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138 128V109.863C138 107.511 139.375 105.375 141.517 104.401L156.483 97.5987C158.625 96.6251 160 94.4894 160 92.1365V89",
    stroke: "#303134"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160 110V89",
    stroke: "#303134"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M160 86V89",
    stroke: "#78797F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M182 128V109.863C182 107.511 180.625 105.375 178.483 104.401L163.517 97.5987C161.375 96.6251 160 94.4894 160 92.1365V89",
    stroke: "url(#paint23_linear_3105_3858)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182 192V210.137C182 212.489 180.625 214.625 178.483 215.599L163.517 222.401C161.375 223.375 160 225.511 160 227.863V231",
    stroke: "#303134"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160 210V231",
    stroke: "#303134"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160 234V231",
    stroke: "#78797F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M138 192V210.137C138 212.489 139.375 214.625 141.517 215.599L156.483 222.401C158.625 223.375 160 225.511 160 227.863V231",
    stroke: "url(#paint24_linear_3105_3858)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3105_3858",
    x: -18,
    y: -88,
    width: 157,
    height: 178.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3105_3858",
    x: 180,
    y: -88,
    width: 157,
    height: 178.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_3105_3858",
    x: 180,
    y: 231,
    width: 157,
    height: 178.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_3105_3858",
    x: -18,
    y: 231,
    width: 157,
    height: 178.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3105_3858",
    x: 24,
    y: 92,
    width: 272,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3105_3858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3105_3858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_3105_3858",
    x: 152,
    y: 110,
    width: 17,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_3105_3858",
    x: 130,
    y: 138,
    width: 17,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_3105_3858",
    x: 196,
    y: 123,
    width: 17,
    height: 75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_3105_3858",
    x: 258,
    y: 152,
    width: 5,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_3105_3858",
    x: 266,
    y: 152,
    width: 5,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_3105_3858",
    x: 274,
    y: 155,
    width: 5,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_3105_3858",
    x: 282,
    y: 155,
    width: 5,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_3105_3858",
    x: 48,
    y: 152,
    width: 5,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_3105_3858",
    x: 40,
    y: 152,
    width: 5,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_3105_3858",
    x: 32,
    y: 155,
    width: 5,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_3105_3858",
    x: 24,
    y: 155,
    width: 5,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_3105_3858",
    x: 108,
    y: 152,
    width: 17,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_3105_3858",
    x: 174,
    y: 150,
    width: 17,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_3105_3858",
    x: 86,
    y: 144,
    width: 17,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_3105_3858",
    x: 218,
    y: 144,
    width: 17,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_3105_3858",
    x: 137,
    y: 231,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_3105_3858",
    x: 137,
    y: 43,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3105_3858",
    x1: 258,
    y1: -88,
    x2: 258,
    y2: 89.0797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3105_3858",
    x1: 60,
    y1: 231,
    x2: 60,
    y2: 408.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3105_3858",
    x1: 244,
    y1: 132,
    x2: 76,
    y2: 188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26272B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3105_3858",
    x1: 160,
    y1: 132,
    x2: 160,
    y2: 188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3105_3858",
    x1: 160,
    y1: 110,
    x2: 160,
    y2: 210,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3105_3858",
    x1: 138,
    y1: 138,
    x2: 138,
    y2: 182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3105_3858",
    x1: 204,
    y1: 123,
    x2: 204,
    y2: 197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3105_3858",
    x1: 260,
    y1: 152,
    x2: 260,
    y2: 168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3105_3858",
    x1: 268,
    y1: 152,
    x2: 268,
    y2: 168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3105_3858",
    x1: 276,
    y1: 155,
    x2: 276,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3105_3858",
    x1: 284,
    y1: 155,
    x2: 284,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3105_3858",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3105_3858",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3105_3858",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3105_3858",
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3105_3858",
    x1: 116,
    y1: 152,
    x2: 116,
    y2: 168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3105_3858",
    x1: 182,
    y1: 150,
    x2: 182,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37373E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3105_3858",
    x1: 94,
    y1: 144,
    x2: 94,
    y2: 176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3105_3858",
    x1: 226,
    y1: 144,
    x2: 226,
    y2: 176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4A53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37373E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3105_3858",
    x1: 160,
    y1: 234,
    x2: 160,
    y2: 274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3105_3858",
    x1: 140,
    y1: 254,
    x2: 180,
    y2: 254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B1BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3105_3858",
    x1: 160,
    y1: 46,
    x2: 160,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3105_3858",
    x1: 140,
    y1: 66,
    x2: 180,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B1BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3105_3858",
    x1: 171,
    y1: 89,
    x2: 171,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3105_3858",
    x1: 149,
    y1: 231,
    x2: 149,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303134"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.803fde46fa804a60bf7f638e28582e18.svg";
export { ForwardRef as ReactComponent };